<template>
    <div class="job">
        <v-container>
            <div class="contentjob">
<!--                <h2>فرصت شغلی</h2>-->
            </div>
            <div class="box-job">
                <v-container>
                    <div class="title-box-job">
                        <Placeholder/>
                    </div>
                </v-container>
            </div>
        </v-container>
    </div>
</template>
<script>
    import Placeholder from "@/components/Placeholder";

    export default {
        name: "job",
        components: {Placeholder},
    };
</script>
<style>
    .job {
        background: #fff;
    }

    .job .contentjob h2 {
        font-size: 20px;
        margin: 1rem 0;
        color: rgb(126, 195, 82);
    }

    .job .contentjob p {
        font-size: 13px;
        line-height: 2;
        color: #000;
    }

    .job .box-job {
        padding: 35px 0 90px 0;
    }

    .job .title-box-job h3 {
        color: #001e60;
        font-size: 20px;
    }

    .job .title-box-job {
        margin: 25px 0;
    }

    .job .items-boxs-job {
        box-shadow: none !important;
    }

    .job .single-boxs-job {
        background-color: #eef7e9 !important;
        border-right: 4px solid #001e60;
        transition: all 0.3s;
        border-bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        margin: 6px 0;
        padding: 10px 0;
        box-shadow: none !important;
    }

    .job .single-boxs-job:nth-child(odd) {
        border-right: 4px solid rgb(126, 195, 82);
        background-color: #d1d6e2 !important;
    }

    .job .single-boxs-job:nth-child(even) .btn-details-box-job .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background: #001e60;
        border: 1px solid #001e60;
    }

    .job .contetn-box-job h5 {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        text-align: right;
        line-height: 30px;
        color: #001e60;
    }

    .job .contetn-box-job {
        display: flex;
        justify-content: space-between;
    }

    .job .text-box-job p {
        font-size: 13px;
        color: #001e60;
    }

    .job .text-box-job h3 {
        font-size: 16px;
        color: #001e60;
        margin: 10px 0;
    }

    .job .btn-details-box-job .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background: rgb(126, 195, 82);
        border: 1px solid rgb(126, 195, 82);
        color: #fff !important;
        font-size: 14px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        letter-spacing: inherit;
    }

    .job .btn-details-box-job {
        display: flex;
        justify-content: flex-end;
        margin: 0 15px;
    }
</style>
